import {Action} from "redux";
import {GetCustomersByClientTopPageRequest} from "../request/customer_request";
import {IClientTopPageActionCreator} from "../action/client_top_page_action";


interface IClientTopPageDispatcher {
    getCustomers(item: GetCustomersByClientTopPageRequest): void;
}

class Dispatcher implements IClientTopPageDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientTopPageActionCreator) {

    }

    public getCustomers = (item: GetCustomersByClientTopPageRequest) => {
        this.dispatch(this.actionCreator.requestGetCustomersByClientTopPageAction(item));
    }

}

const createClientTopPageDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientTopPageActionCreator): IClientTopPageDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientTopPageDispatcher, createClientTopPageDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_top_page_dispatcher.ts